import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from 'containers/App/routes';

const certificatesRoot = 'ca_certificates';
export const certificatesOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${certificatesRoot}`;
